$(window).load(function () {
    // Id for popup
    const productIdList = [4460, 4320, 4598, 4744, 4932, 5079, 5225, 5371, 5517, 5663, 5801, 6048, 5939, 4607, 3062, 6181, 8638, 7572, 7806, 8712, 8181, 8453, 7883, 8779, 9296, 8847, 8520, 7666, 8312, 8386, 9171, 7957, 8005, 9233, 8243];

    const idLogoPopUp = `${FULLCLIENTTHEMEPATH}images/ada-icon.png`;


    // Check for event to trigger popup
    function launchPopUpById() {
        const idProducts = $(".listingItem");

        idProducts.each(function (i) {
            // $(this).find('.buyButton[data-itemid="3062"]').attr('href', 'https://www.sdfair.com/reservations.aspx?pid=6181&iid=4607')
            const buyButton = $(this).find('.buyNowButton');

            buyButton.on('click', function (event) {

                const urlClicked = $(this).attr('href');
                const containsProductId = productIdList.some(id => urlClicked.includes(`pid=${id}`));

                if (containsProductId) {
                    event.preventDefault();
                    idPopUpLaunch();
                    $('#yes-url-seats').attr('href', urlClicked)
                }
            });
        });
    }

    launchPopUpById()

    function idPopUpLaunch() {

        const closePopup = function () {
            $('#cart-pop').fadeOut('fast', function () {
                $('#cart-pop').remove();
            });
        }

        function trapFocus() {
            const firstFocusable = $('#cart-pop-btn-yes');
            const lastFocusable = $('#cart-pop-btn-no');

            firstFocusable.on('keydown', (event) => {
                if (event.key === 'Tab') {
                    if (event.shiftKey) {
                        event.preventDefault();
                        lastFocusable.focus();
                    }
                }
            });

            lastFocusable.on('keydown', (event) => {
                if (event.key === 'Tab') {
                    if (!event.shiftKey) {
                        event.preventDefault();
                        firstFocusable.focus();
                    }
                }
            });
        }

        const idPopupHTML = `
                <div id="cart-pop" class="cart-pop">
                    <div class="cart-pop__content">

                    <span class="top-text">Notice:</span>
                        
                        <h2>Americans with Disabilities Act (ADA) Accessible Seating</h2>
                        <div class="cart-pop__text">
                        
                        <img src="${idLogoPopUp}" class="ada-icon">

                        <div class="ada-content">
                            <span class="text">
                            By purchasing ADA Accessible seats, fans verify that they, or someone they are purchasing tickets for, require the features of an accessible seat.
                            </span>
                        
                            <span class="warning-content">Tickets purchased fraudulently are subject to cancellation</span>
                        </div>

                        </div>
                        <div class="cart-pop__buttons">
                            <a id="yes-url-seats"><button id="cart-pop-btn-yes" class="button">Proceed</button></a>
                            <button id="cart-pop-btn-no" class="button">No Thanks</button>
                        </div>
                    </div>
                </div>
            `;

        $('body').prepend(idPopupHTML);
        trapFocus();

        $(document).on('keydown', function (event) {
            if (event.key == 'Escape') {
                closePopup();
            }
        });


        $('#cart-pop-btn-yes').on('keypress click', function (event) {
            if (event.key == 'Enter' || event.type == 'click') {
                closePopup();
            }
        });


        $('#cart-pop-btn-no').on('keypress click', function (event) {
            if (event.key == 'Enter' || event.type == 'click') {
                closePopup();
            }
        })

    }
});



